const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  thirdUser: state => state.user.thirdUserInfo
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js